module.exports = __webpack_public_path__ + "media/frontend/components/lobby/bg-lobby-b80a2a08f412a6232d45b11b819fd152.png";